import { getScaledAttr } from './helper';
import { getStyles as getStylesVsme } from '../vsme/getStyles';
import { SectionStyle } from '../../../helpers/SectionStyle';

export function getStyle(key: string, isPDF?: boolean, fontFactor?: number, layout?: string, params?: any) {
    const fontFamily = 'Helvetica';
    const fontFamilyBold = 'Helvetica-Bold';
    // const fontFamily = 'Calibri';
    // const fontFamilyBold = 'Calibri-Bold';
    const factorFonts = fontFactor ? fontFactor : 1;
    // const fontSizeBig = `${Math.floor(10 * factorFonts)}pt`;
    // const fontSizeNorm = `${Math.round(8 * factorFonts)}pt`;
    // const fontSizeSmall = `${Math.ceil(6 * factorFonts)}pt`;
    const fontSizeBig = `${Math.floor(9 * factorFonts)}pt`;
    const fontSizeNorm = `${Math.round(8 * factorFonts)}pt`;
    const fontSizeSmall = `${Math.ceil(7 * factorFonts)}pt`;

    const fontColorNorm = '#555';
    const containerId: string = typeof SectionStyle.curPrintSectionId === 'number' ? SectionStyle.getCurrentClass(true) : null;
    const Section: any = new SectionStyle(containerId);
    const [
        backgroundColorHeadline,
        backgroundColorSection,
        backgroundColorSectionTable,
        backgroundColorSectionTableHighlight,
        colorSection,
        colorSectionText,
        fontSizeHeadline,
        heightHeadline,
    ] = Section.getPropertyValues([
        '--color-bg-headline',
        '--color-section-main',
        '--color-section-table-background',
        '--color-section-table-highlight',
        '--color-button-text',
        '--color-section-text',
        '--font-size-headline',
        '--height-headline'
    ]);

    const stylesVsme: any = getStylesVsme(isPDF, { ...params, fontFamily, fontFamilyBold, fontSizeBig, fontSizeNorm, fontSizeSmall }) || {};
    // console.log('Sizes:' , fontSizeBig, factorFonts, fontSizeNorm, fontSizeSmall);

    const def: any = {
        ...stylesVsme,
        main: {
            display: 'flex',
            flexDirection: 'column',
            // ...(isPDF ? { padding: 0, paddingBottom: 15 } : { padding: 20 }),
            ...(isPDF
                ? { padding: 0, paddingBottom: 15 }
                : { margin: 20, borderTopLeftRadius: 10, borderTopRightRadius: 10, boxShadow: 'var(--assistent-box-shadow)' }
            ),
            fontFamily: fontFamily
        },
        rows_main: {
            display: 'flex',
            flexDirection: 'column'
        },
        row: {
            display: 'flex',
            flexDirection: 'row'
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            fontWeight: 'bold',
            fontFamily: fontFamilyBold
        },
        header_block: {
            display: 'flex',
            flexDirection: 'column',
            whiteSpace: 'pre-line' // Zeilenumbruch
        },
        header_cols: {
            display: 'flex',
            flexDirection: 'row',
            minHeight: 35,
            flex: 1
        },
        header_text_block: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            // backgroundColor: '#bccae3',
            backgroundColor: backgroundColorSection || '#bccae3',
            fontSize: fontSizeNorm,
            minHeight: 35,
            boxSizing: 'border-box',
            textAlign: 'center',
            borderLeft: '1pt solid #fff',
            flex: 1,
            // color: fontColorNorm
            color: colorSection || fontColorNorm
        },
        header_text_col: {
            display: 'flex',
            flexDirection: 'column',
            // backgroundColor: '#bccae3',
            backgroundColor: backgroundColorSection || '#bccae3',
            fontSize: fontSizeSmall,
            textAlign: 'center',
            // color: fontColorNorm,
            color: colorSection || fontColorNorm,
            boxSizing: 'border-box',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            flex: 1
        },
        header_text_field: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            // color: fontColorNorm,
            color: colorSection || fontColorNorm,
            boxSizing: 'border-box',
            paddingTop: 3,
            flex: 1,
            overflow: 'hidden'
        },
        row_field: {
            // color: '#4f81bd',
            color: colorSectionText || '#4f81bd',
            fontSize: fontSizeNorm,
            // backgroundColor: '#ddd',
            backgroundColor: backgroundColorSectionTable || '#ddd',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            height: isPDF ? 15 : 23,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_header: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            // color: fontColorNorm,
            color: colorSection || fontColorNorm,
            // backgroundColor: '#bccae3',
            backgroundColor: backgroundColorSection || '#bccae3',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_header_green: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_header_green2: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_hidden: {
            maxHeight: 0,
            display: 'none',
            visibility: 'hidden',
            overflow: 'hidden'
        },
        row_field_green_scope: {
            /*fontWeight: 'bold',
            fontFamily: fontFamilyBold,*/
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_scope_left: {
            /*fontWeight: 'bold',
            fontFamily: fontFamilyBold,*/
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_scope_right: {
            /*fontWeight: 'bold',
            fontFamily: fontFamilyBold,*/
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingRight: '5pt',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_kategorie_scope_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bbb',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_kategorie_scope_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bbb',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingRight: '5pt',
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_kategorie_scope_plain: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bbb',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_scope: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#787878',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_scope_visible: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#787878',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_oos_scope_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#787878',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden',
            paddingRight: '20pt'
        },
        row_field_oos_scope_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#787878',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingRight: '5pt',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_heading: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#c5ceb9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_heading_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#c5ceb9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_heading_plain: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#c5ceb9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_heading_plain_visible: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#c5ceb9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_green_heading_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#c5ceb9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_heading: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bababa',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_heading_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bababa',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_heading_plain: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bababa',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_oos_heading_plain_visible: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bababa',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_oos_heading_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#bababa',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_sum_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_sum_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_sum_right_lb: {
            color: '#888',
            fontWeight: 'bold',
            fontSize: fontSizeNorm,
            backgroundColor: '#fff',
            fontFamily: fontFamilyBold,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_sum_right_help: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_oos_sum_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#787878',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_sum: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 20,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_left_0mt: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 0,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_total_left: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#fff',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 20,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_total_left_lb: {
            color: '#888',
            fontStyle: 'italic',
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            backgroundColor: '#fff',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 20,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_right_0mt: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 0,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_right_help: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_green_total_right_help_0mt: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 0,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'visible'
        },
        row_field_white_total_right: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#fff',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_total_right_lb: {
            color: '#888',
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            backgroundColor: '#fff',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green_total_0mt: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#fff',
            backgroundColor: '#728A49',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 0,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_total: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            backgroundColor: '#fff',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            marginTop: 20,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic: {
            // color: '#4f81bd',
            color: colorSectionText || '#4f81bd',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            // backgroundColor: '#ddd',
            backgroundColor: backgroundColorSectionTable || '#ddd',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic_grey: {
            color: '#888',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_left: {
            color: '#000',
            fontSize: fontSizeNorm,
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '15pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic_left: {
            color: '#000',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            // backgroundColor: '#ddd',
            backgroundColor: backgroundColorSectionTable || '#ddd',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            paddingLeft: '15pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic_grey_left: {
            color: '#888',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '15pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_right: {
            color: '#000',
            fontSize: fontSizeNorm,
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic_right: {
            color: '#000',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            // backgroundColor: '#ddd',
            backgroundColor: backgroundColorSectionTable || '#ddd',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_italic_grey_right: {
            color: '#888',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_center: {
            color: '#000',
            fontSize: fontSizeNorm,
            backgroundColor: '#F7F7F7',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white: {
            color: '#000',
            fontWeight: 'bold',
            fontSize: fontSizeNorm,
            backgroundColor: '#fff',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_lb: {
            color: '#888',
            fontStyle: 'italic',
            fontWeight: 'bold',
            fontSize: fontSizeNorm,
            backgroundColor: '#fff',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'left',
            paddingLeft: '5pt',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_white_right: {
            color: '#000',
            fontWeight: 'bold',
            fontSize: fontSizeNorm,
            backgroundColor: '#fff',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingLeft: '5pt',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_empty: {
            color: '#fff',
            fontSize: fontSizeNorm,
            fontStyle: 'italic',
            backgroundColor: '#fff',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_dark: {
            // color: '#254060',
            color: colorSectionText || '#254060',
            fontSize: fontSizeNorm,
            // backgroundColor: '#b5b4b4',
            backgroundColor: backgroundColorSectionTableHighlight || '#b5b4b4',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_green: {
            // color: '#0a0',
            color: fontColorNorm,
            fontSize: fontSizeNorm,
            backgroundColor: '#ddd',
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: isPDF ? 2 : 3,
            height: isPDF ? 15 : 23,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_sum: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            // backgroundColor: '#e9e9e9',
            backgroundColor: backgroundColorSectionTableHighlight || '#e9e9e9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingLeft: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden'
        },
        row_field_sum_right_highlight: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            // backgroundColor: '#e9e9e9',
            backgroundColor: backgroundColorSectionTableHighlight || '#e9e9e9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden',
            borderBottom: `3pt solid ${backgroundColorSection || '#728a49'}`
        },
        row_field_oos_sum_right_highlight: {
            fontWeight: 'bold',
            fontFamily: fontFamilyBold,
            color: '#000',
            // backgroundColor: '#e9e9e9',
            backgroundColor: backgroundColorSectionTableHighlight || '#e9e9e9',
            fontSize: fontSizeNorm,
            borderTop: '1pt solid #fff',
            borderLeft: '1pt solid #fff',
            textAlign: 'right',
            paddingTop: isPDF ? 4 : 6,
            paddingBottom: isPDF ? 3 : 4,
            paddingRight: '5pt',
            height: 25,
            boxSizing: 'border-box',
            overflow: 'hidden',
            borderBottom: '3pt solid #787878'
        },
        tableTitle: {
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: colorSectionText || '#333',
            backgroundColor: backgroundColorHeadline || '#ddd',
            padding: isPDF ? '1px 3px 3px 3px' : '0 20px 0 20px',
            ...(isPDF
                ? { fontFamily: fontFamilyBold, fontSize: '11pt' }
                : { fontWeight: 600, fontSize: fontSizeHeadline }
            ),
            textAlign: 'center',
            width: '100%',
            ...(!isPDF && {
                minHeight: heightHeadline,
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
            }),
            lineHeight: isPDF ? 1 : 1.3
        },
        diagrammWrapper: {
            fontFamily: fontFamily,
            // width: '100%',
            // height: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            overflowX: 'auto',
            color: fontColorNorm,
            fontSize: '10pt',
            padding: 0,
            // ...(!isPDF && { paddingRight: 20, paddingLeft: 20 })
            ...(!isPDF && {  margin: '-10px 0 -10px 0', padding: '10px 20px 10px 20px' })
        },
        diagramm: {
            backgroundColor: backgroundColorSectionTable || 'transparent',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            // border: '1px solid #ddd',
            ...(isPDF && {
                border: `1px solid`,
                borderColor: backgroundColorHeadline || '#ddd',
            }),
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // height: 300,
            height: 250,
            marginRight: 10,
            overflow: 'hidden',
            boxShadow: 'var(--assistent-box-shadow)'
        },
        diagrammTitle: {
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            // color: '#333',
            color: colorSectionText || '#333',
            // backgroundColor: '#ddd',
            backgroundColor: backgroundColorHeadline || '#ddd',
            // padding: isPDF ? '1px 3px 3px 3px' : '5px 0 5px 0',
            padding: isPDF ? '1px 3px 3px 3px' : '0 20px 0 20px',
            // ...(isPDF && { fontFamily: fontFamilyBold, fontSize: '11pt' }),
            ...(isPDF
                ? { fontFamily: fontFamilyBold, fontSize: '11pt' }
                : { fontWeight: 600, fontSize: fontSizeHeadline }
            ),
            textAlign: 'center',
            width: '100%',
            ...(!isPDF && {
                minHeight: heightHeadline,
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
            }),
            lineHeight: isPDF ? 1 : 1.3,
            marginBottom: 7
        },
        legendWrapper: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            maxHeight: 30,
            ...(isPDF && { marginBottom: -8 })
        },
        legendTitel: {
            fontFamily: fontFamily,
            fontSize: fontSizeNorm,
            // ...(isPDF && { backgroundColor: 'white' }),
            margin: '0 5px 0 5px',
            display: 'flex',
            flexDirection: 'row'
        },
        legendIcon: {
            width: 6,
            height: 6,
            ...(isPDF && { margin: 'auto', marginRight: 3 })
        },
        bemerkung: {
            fontFamily: fontFamily,
            fontSize: fontSizeNorm,
            margin: 0,
            padding: 0,
            paddingTop: 5,
            display: 'flex',
            flexDirection: 'row'
        },
        sub: {
            fontSize: '5pt'
        },
        footer: {
            position: 'absolute',
            bottom: 15,
            left: 40,
            fontSize: fontSizeNorm
        },
        footerPages: {
            position: 'absolute',
            right: 40,
            bottom: 15,
            fontSize: fontSizeNorm
        }
    };
    const style = def[key] || {};

    if (!isPDF) {
        const scale = 1.5, fontScale = 1.0;

        if (key === 'row_field' || key === 'row_field_dark' || key === 'row_field_green'
            || key === 'row_field_header' || key === 'row_field_header_green2'
            || key === 'header_text_block' || key === 'header_text_col') {

            const attr = ['height', 'minHeight', 'maxHeight'];
            attr.forEach((att: string) => {
                style[att] = getScaledAttr(style[att], scale);
            });
            if (style.fontSize) {
                style.fontSize = getScaledAttr(style.fontSize, fontScale);
            }
        }
    } else {
        if (layout === 'Jahresauswertung') {
            const scale = 0.7;
            const attr = ['height', 'minHeight', 'maxHeight'];
            attr.forEach((att: string) => {
                // console.log(key, att, style[att]);
                style[att] = style[att] * scale;
            });
        }
    }

    return style;
}
